import { API_ROOT_URL } from '../config';

export const reportsService = {
	fetchCounsellorReport,
	fetchCorporateReport,
};

function fetchCounsellorReport(startDate, endDate, projects,counsellors) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},

	};
	return fetch(`${API_ROOT_URL}/administrator/counsellor-reports/?start_date=${startDate}&end_date=${endDate}&projects=${projects}&counsellors=${counsellors}`, requestOptions).then((response) =>
		response.json()
	);
}

function fetchCorporateReport(startDate, endDate, projects) {
	const token = JSON.parse(localStorage.getItem('token'));
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,			
		},
	};
	return fetch(`${API_ROOT_URL}/administrator/corporate-reports/?start_date=${startDate}&end_date=${endDate}&projects=${projects}`, requestOptions).then((response) =>
		response.json()
	);
}



// WEBPACK FOOTER //
// ./src/services/reportsService.js